<template>
  <a-spin :spinning="formOption.busy">
    <a-form :form="form"
            :label-col="{ span: 12 }"
            :wrapper-col="{ span: 12 }"
    >
      <div class="form_title">基本信息</div>
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="客户名称">
            <a-input v-decorator="['customerName']" :disabled="true"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="联系人姓名">
            <a-input v-decorator="['name']" :disabled="true"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="联系人手机">
            <a-input v-decorator="['contactPhone']" :disabled="true"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="跟进人">
            <a-input v-decorator="['lastSaleUserName']" :disabled="true"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="最近跟进时间">
            <a-input v-decorator="['lastCallonDate']" :disabled="true"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="下次跟进时间">
            <a-input v-decorator="['nextCallonDate']" :disabled="true"/>
          </a-form-item>
        </a-col>
      </a-row>
      
      <div class="form_title">意向信息</div>
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="意向等级">
            <a-input v-decorator="['nextWantLevelName']" :disabled="true"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="意向品系">
            <a-input v-decorator="['wantStrainName']" :disabled="true"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="预购数量">
            <a-input v-decorator="['wantCount']" :disabled="true"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="预计购车日期">
            <a-input v-decorator="['estimateBuyDate']" :disabled="true"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="客户关注点">
            <a-input v-decorator="['customerAttentionName']" :disabled="true"/>
          </a-form-item>
        </a-col>
      </a-row>
      
      <div v-if="isFail">
        <div class="form_title">战败信息</div>
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="战败时间">
              <a-input v-decorator="['failDate']" :disabled="true"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="战败原因">
              <a-input v-decorator="['failReason']" :disabled="true"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="流失品牌">
              <a-input v-decorator="['lostBrandName']" :disabled="true"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="战败数量">
              <a-input v-decorator="['lostNum']" :disabled="true"/>
            </a-form-item>
          </a-col>
        </a-row>
      </div>

      <div v-if="isDeal">
        <div class="form_title">成交信息</div>
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="成交时间">
              <a-input v-decorator="['dealDate']" :disabled="true"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="订车日期">
              <a-input v-decorator="['dealDate']" :disabled="true"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="成交数量">
              <a-input v-decorator="['dealCount']" :disabled="true"/>
            </a-form-item>
          </a-col>
        </a-row>
      </div>

    </a-form>
    <a-tabs>
      <a-tab-pane key="1" tab="大客户跟进记录" :forceRender="true">
        <clueProp ref="clueProp" :rowId="rowId"></clueProp>
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>

<script>
import {formMixin, fmt} from '@/utils/common/FormBase';
import {bigDataApi} from "@/services/bigCustomer/followRecord";
import clueProp from "@/pages/web/bigCustomer/followRecord/detail/bigCustomerProp";

/**
 * 加载数据
 */
async function loadEntity(rowId) {
  let entity = await bigDataApi.getDetail(rowId);
  //交车
  if(entity.data.nextWantLevel === '200025'){
    this.isDeal = true;
  }
  //战败
  if(entity.data.nextWantLevel === '200026'){
    this.isFail = true;
  }
  return fmt.formatFormLoad(entity);
}

/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 */
function newEntity() {
  return {};
}

/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
async function afterLoad(entity) {
  console.log(entity)
  console.log(this.keyId)
  if (this.keyId) {
    let res = await bigDataApi.getDetailFollowRecord(this.keyId)
    console.log('数据',res);
    this.setRefsValue({
      clueProp: res.data,
    })
  }
}

export default {
  mixins: [formMixin],
  components: {
    clueProp,
  },
  data() {
    return {
      isDeal: false,
      isFail: false,
    }
  },
  methods: {
    loadEntity,
    newEntity,
    afterLoad, 
  },
};
</script>

<style scoped lang="stylus">
/deep/ .vxe-toolbar {
  height 10px
}
.contract_img{
  width: 100%;

}
.contract_img img{
  width:100px;
  height:  120px;
  object-fit cover
  margin-right 32px
}
.contract_img img:first-child{
  margin-left: 78px;
}
</style>
